// Vindicati Scroller
(function($) {

    function initVindicatiScroller() {

        $(document).on('click.scrollVW', '.gallery-footer__subnav a.disable', function(e){
            //Quick and Dirty horizontal scroller. Moves offset of last visible item in viewport.
            e.preventDefault();
            function isElementInViewport (el) {

                    if (typeof jQuery === "function" && el instanceof jQuery) {
                            el = el[0];
                    }

                    var rect = el.getBoundingClientRect();

                    return (
                            rect.top >= 0 &&
                            rect.left >= 0 &&
                            rect.right <= (window.innerWidth || document.documentElement.clientWidth) /*or $(window).width() */
                    );
            }

            var $target = $('.grid-gallery-thumbnails');
            var $this = $(this);
            var direction = $this.attr('href').toLowerCase() == '#prev' ? '-' : '+';
            var pos = '';
            var $galleryItems = $target.find('.gallery-thumbnail').filter(function( ) { return isElementInViewport(this);});
            console.log('i', $galleryItems);
            if (direction == '+') {
                    //$target.find('.active').next().addClass('.active').siblings().removeClass('.active');
                    if ($galleryItems.last().next().length){
                            pos = '+=' + $galleryItems.last().next()[0].getBoundingClientRect().x + 'px';
                    }
            }
            else if (direction == '-') {
                    if ($galleryItems.first().prev().length) {
                            pos = '-=' + (document.documentElement.clientWidth + $galleryItems.first().prev()[0].getBoundingClientRect().x + $galleryItems.first().prev()[0].getBoundingClientRect().width) + 'px';
                    }
            }
            else {
                    pos = direction + '=' + document.documentElement.clientWidth + 'px';
            }

            if (pos.length > 0) {
                    $target.animate( { scrollLeft: pos }, 1000, 'easeInOutQuad');
            }

		});

    }

    if ( $( 'body' ).hasClass( 'single' ) ){

        if( $( 'body' ).hasClass( 'article-content-loaded' ) ){
            initVindicatiScroller();
            console.log( 'scrollers called after .article-content-loaded in body tag' );
        } else {
            $( document ).on( 'aw_article_content_loaded', function(){
                initVindicatiScroller();
                console.log( 'scrollers called after aw_article_content_loaded' );
            } );
        }
    } else {
        initVindicatiScroller();
        console.log( 'scrollers called without aw_article_content_loaded' );
    }
})(jQuery);

//Galleries
(function () {
    // "Original Video" Page selectors
    const teaserGalleryWrapper = '.section--teaser_gallery';
    const teaserGalleryContainer = teaserGalleryWrapper + ' .grid-gallery';
    const teaserGalleryArrows = teaserGalleryWrapper + ' nav a';

    // "Partner Experts" page selectors
    const gridScrollerWrapper = '.grid-scroller';
    const gridScrollerContainer = gridScrollerWrapper + ' .grid-scroller__container';
    const gridScrollerArrows = gridScrollerWrapper + ' nav a';

    const galleryWrapper = teaserGalleryWrapper + ',' + gridScrollerWrapper,
        galleryContainer = teaserGalleryContainer + ',' + gridScrollerContainer,
        galleryArrows = teaserGalleryArrows + ',' + gridScrollerArrows;

    // A handler of clicks on the control arrows
    (() => {
        // A gallery item is considered visible even if a specified part of the element is hidden from the viewport
        const allowedScrollOffset = 0.1;

        // Visible items in the current viewport
        const getCurrentlyVisibleItems = (container) => {
            const containerDOMRect = container[0].getBoundingClientRect();

            return container.children().filter(function () {

                const itemDOMRect = this.getBoundingClientRect();

                // Applying the offset
                return itemDOMRect.left > containerDOMRect.left - (itemDOMRect.width * allowedScrollOffset) &&
                    itemDOMRect.right < containerDOMRect.right + (itemDOMRect.width * allowedScrollOffset);
            });
        };

        const scrollLeft = (container) => {

            const items = container.children();
            // Default value to scroll (the first item in the gallery)
            let scrollTo = items[0].scrollLeft;

            const containerWidth = container.width(),
                galleryItemWidth = items.outerWidth();

            // Calculate how many items fit in the viewport by default (if the page just loaded)
            const defaultAmountOfItemsInViewport = Math.trunc((containerWidth + (galleryItemWidth * allowedScrollOffset)) / galleryItemWidth);

            // Get visible items in the current state...
            const currentlyVisibleItems = getCurrentlyVisibleItems(container);

            // ... and set an index of the item to scroll to
            const targetElementIndex = currentlyVisibleItems.first().index() - defaultAmountOfItemsInViewport;

            // If it is a valid index, get its position
            if (targetElementIndex > 0) {
                //Respect of possible offset of the first item since it is not always zero
                scrollTo = items[targetElementIndex].offsetLeft - items[0].offsetLeft;
            }

            return scrollTo;
        };

        const scrollRight = (container) => {

            const items = container.children();

            // Default value to scroll (the last item in the gallery)
            let scrollTo = container[0].scrollWidth - container[0].offsetWidth;

            // Get visible items in the current state...
            const currentlyVisibleItems = getCurrentlyVisibleItems(container);
            // ... and get the item to scroll to
            const targetElement = currentlyVisibleItems.last().next();

            // Get its position
            if (targetElement.length) {
                // Respect of possible offset of the first item
                scrollTo = targetElement[0].offsetLeft - items[0].offsetLeft;
            }

            return scrollTo;
        };

        const scrollHandler = (element) => {
            const button = $(element);
            const container = button.closest(galleryWrapper).children(galleryContainer);
            let scrollTo;

            if ('Previous' === button.attr('aria-label')) {
                scrollTo = scrollLeft(container);
            } else {
                scrollTo = scrollRight(container);
            }

            container.animate({scrollLeft: scrollTo}, 1000, 'easeInOutQuad');
        };

        $(document).on('click', galleryArrows, function (event) {
            event.preventDefault();
            scrollHandler(this);
        });

    })();

    // A handler of visibility of the control arrows
    (() => {

        const showArrowClassName = 'show-arrow-button',
            prevStatePropName = 'awGalleryPrevState';
        let leftOffset, rightOffset;

        const setOffset = () => {
            const defaultOffset = 170;

            // 'Partner Experts' page
            if(0 === $(teaserGalleryContainer).length){
                leftOffset = rightOffset = defaultOffset;
                return;
            }

            // 'Original video' page
            const items = $(teaserGalleryContainer).children();

            const itemWidth = parseInt(items.css('width'), 10),
                itemMaxWidth = parseInt(items.css('maxWidth'), 10);

            leftOffset = itemWidth / 2;
            // The difference between sizes due to the hover effect
            rightOffset = itemMaxWidth - itemWidth;

        };

        const visibilityHandler = (container) => {

            const $container = $(container);
            const nav = $container.siblings('nav');

            const left = container.scrollLeft,
                right = container.scrollWidth - container.scrollLeft - container.offsetWidth;

            let leftButton, rightButton,
                showLeft = left > leftOffset,
                showRight = right > rightOffset;

            // When a gallery doesn't have scroll we hide control elements
            if (container.scrollWidth === container.offsetWidth) {
                showRight = false;
                showLeft = false;
            }

            // Since we are mainly listening to the scrolling events and they are fired at a high rate,
            // it makes sense to save the previous state and make changes to DOM only if something has been changed
            if (undefined === $container.data(prevStatePropName)) {
                $container.data(prevStatePropName, {
                    left: undefined,
                    right: undefined,
                });
            }

            if (showLeft !== $container.data(prevStatePropName).left) {
                leftButton = nav.find('.page-link[aria-label="Previous"]')[0];
                leftButton.classList.toggle(showArrowClassName, showLeft);
                $container.data(prevStatePropName).left = showLeft;
            }

            if (showRight !== $container.data(prevStatePropName).right) {
                rightButton = nav.find('.page-link[aria-label="Next"]')[0];
                rightButton.classList.toggle(showArrowClassName, showRight);
                $container.data(prevStatePropName).right = showRight;
            }
        };
        window.visibilityHandler = visibilityHandler;

        // When all galleries has been loaded
        $(window).on('load aw_video_galleries_built resize', function () {
            setOffset();

            $(galleryContainer).each(function () {
                visibilityHandler(this);
            });
        });

        // Capturing scroll event
        document.addEventListener('scroll', function (event) {
            if ($(event.target).is(galleryContainer)) {
                visibilityHandler(event.target);
            }
        }, true);

        document.addEventListener('aw_infinite_loading.complete', function (event) {
            visibilityHandler(event.target);
        });

    })();

    // A handler that removes lazy image loading in the galleries
    (() => {
        const gridScrollerImage = '.grid-scroller__item-container picture img.image';

        const handleImages = (container) => {
            $(container).find(gridScrollerImage).attr('loading', 'eager');
        };

        $(window).on('load', function () {
            $(galleryContainer).each(function () {
                handleImages(this);
            });
        });

        document.addEventListener('aw_infinite_loading.complete', function (event) {
            handleImages(event.target);
        });
    })();

})(jQuery);
